export default Object.freeze({
	Connected: 'Connected',
	NotConnected: 'NotConnected',
	Error: 'Error',
});
